import React from "react";
import { Serie } from "../types/Serie";
import { Link } from "react-router-dom";

type Props = {
  serie: Serie;
};

const DefaultCover = (props: Props) => {
  const { serie } = props;
  return (
    <Link to={`/serie/${serie.id}`}>
      <div
        style={{
          height: 219,
          aspectRatio: 165 / 219,
          borderRadius: 8,
          overflow: "hidden",
          marginLeft: 5,
          marginRight: 5,
          marginTop: 10,
        }}
      >
        <img
          style={{
            height: "100%",
            width: "100%",
            backgroundColor: "#C3C3C3",
          }}
          src={`https://newbrand.s3.eu-west-3.amazonaws.com/series/${
            serie.uid
          }/couvertures/${serie.cover || serie.img}`}
          alt=""
        />
      </div>
    </Link>
  );
};

export default DefaultCover;
